import { SetState } from 'zustand';
import { ITransaction } from '../types';

export interface ICategoriesDrawerSlice {
  activeDrawerTransaction: ITransaction | null;
  setActiveDrawerTransaction: (transaction: ITransaction | null) => void;
  selectedCategoryDetails: {
    categoryId: string;
    businessPercent: number;
  } | null;
  setSelectedCategoryDetails: (selectedCategoryDetails: { categoryId: string, businessPercent: number } | null) => void;
  resetCategoriesDrawerSlice: () => void;
}

const createCategoriesDrawerSlice = (set: SetState<ICategoriesDrawerSlice>) => ({
  activeDrawerTransaction: null,
  setActiveDrawerTransaction: (transaction: ITransaction | null) => {
    set({ activeDrawerTransaction: transaction });
  },
  selectedCategoryDetails: null,
  setSelectedCategoryDetails: (selectedCategoryDetails: { categoryId: string, businessPercent: number } | null) => {
    set({ selectedCategoryDetails });
  },
  resetCategoriesDrawerSlice: () => {
    set({
      activeDrawerTransaction: null,
      selectedCategoryDetails: null,
    });
  },
});

export default createCategoriesDrawerSlice;
